import Api from '@/api'

const state = {}

const getters = {}

const mutations = {}

const actions = {
  async getPending(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const response = await Api.AccountStatement.getPending(params)
    return (response && response.rows) || []
  },

  async getPendingItems(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const response = await Api.AccountStatement.getPendingItems(params)
    // Un error no es "nada pendiente": con null la vista lo dice en vez de
    // vaciar la tabla (y, al refrescar, no borra lo que ya mostraba).
    if (!response || !Array.isArray(response.items)) return null
    return response.items
  },

  async getAll(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const response = await Api.AccountStatement.getAll(params)
    return response && response.rows ? response : { rows: [], total: 0 }
  },

  async getOne(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    return Api.AccountStatement.getOne(params)
  },

  async create(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    return Api.AccountStatement.create(params)
  },

  async pay(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    return Api.AccountStatement.pay(params)
  },

  async deletePayment(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    return Api.AccountStatement.deletePayment(params)
  },

  async voidStatement(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    return Api.AccountStatement.voidStatement(params)
  },

  async send(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    return Api.AccountStatement.send(params)
  },

  async uploadDocuments(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    return Api.AccountStatement.uploadDocuments(params)
  },

  async deleteDocument(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    return Api.AccountStatement.deleteDocument(params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
